import { MimeType } from '@rad/components/inputs/file-input-with-previews';
export const IMAGE_MIME_TYPES = [MimeType.Png, MimeType.Jpeg, MimeType.Jpg, MimeType.Gif, MimeType.Webp];
export const isImage = (a) => IMAGE_MIME_TYPES.includes(a.mimeType);
export const defaultVariant = (a) => { var _a, _b; return (_b = (_a = a.attachments.find(v => v.isDefault)) !== null && _a !== void 0 ? _a : a.attachments.find(v => v.label !== 'header')) !== null && _b !== void 0 ? _b : a.attachments[0]; };
export const headerVariant = (a) => a.attachments.find(v => v.label === 'header');
export const resolveHeaderUrl = (images, headerVariants) => {
    var _a, _b, _c, _d;
    const primary = (_b = (_a = images.find(a => a.isMain)) !== null && _a !== void 0 ? _a : images[0]) !== null && _b !== void 0 ? _b : null;
    const header = (primary === null || primary === void 0 ? void 0 : primary.assetId) ? headerVariants.find(h => h.assetId === primary.assetId) : undefined;
    return (_d = (_c = (header !== null && header !== void 0 ? header : primary)) === null || _c === void 0 ? void 0 : _c.url) !== null && _d !== void 0 ? _d : null;
};
export const IMAGE_CATEGORIES = ['exterior', 'interior', 'detail', 'historic', 'renovation', 'other', 'uncategorized'];
export const ATTACHMENT_CATEGORY = {
    exterior: { label: 'Exterior', icon: 'bi bi-house' },
    interior: { label: 'Interior', icon: 'bi bi-door-open' },
    detail: { label: 'Detail', icon: 'bi bi-zoom-in' },
    historic: { label: 'Historic', icon: 'bi bi-clock-history' },
    renovation: { label: 'Renovation', icon: 'bi bi-tools' },
    other: { label: 'Other', icon: 'bi bi-folder' },
    uncategorized: { label: 'Uncategorized', icon: 'bi bi-question-circle' },
};
export const CATEGORY_OPTIONS = Object.entries(ATTACHMENT_CATEGORY).map(([value, { label }]) => ({ value, label }));
